export default __webpack_public_path__ + "static/media/0xa9536b9c75a9e0fae3b56a96ac8edf76abc91978.81489d36.webp";